'use strict';

function DemandManagementDirective() {
  return {
    restrict: 'E',
    template: require('../templates/demand-management.html'),
    controller: 'DemandManagementController',
    scope: {
      selectedFlights: '<',
      reoptPreviewData: '=',
      demandManagementData: '='
    },
    link: function link(scope) {
      scope.$watch('selectedFlights', scope.onSelectFlights);
    }
  };
}
DemandManagementDirective.$inject = [];
module.exports = DemandManagementDirective;